import { RoleItemProps } from "apis";
import { lazy } from "react";

export const PageAdminRole = lazy(() => import("./List"));
export const PageAdminRoleCreate = lazy(() => import("./Add"));
export const PageAdminRoleUpdate = lazy(() => import("./Edit"));
export const PageAdminRolePermissionAccessControll = lazy(() => import("./AccessControllPermission"));
export const PageAdminRoleFormAccessControll = lazy(() => import("./AccessControllForm"));

export interface FormRoleValuesProps extends RoleItemProps { }